import { getTenantToken } from 'app/utils/enviromentUtil';
import axiosDefault from 'axios';
import axios from './financeiroApi';

const publicoApi = () => {
  const getPath = () => {
    return `/api/v1/backend/public`;
  };

  return {
    pedidoCompraProduto: (uuid, tenantId) => {
      const url = `${getPath()}/compra/produto/pedido/${uuid}`;
      return axios.get(url, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    pedidoVenda: (uuid, tenantId) => {
      const url = `${getPath()}/venda/pedido/${uuid}`;
      return axios.get(url, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    boleto: (uuid, tenantId) => {
      const url = `${getPath()}/conta-receber/boleto/${uuid}`;
      return axios.get(url, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    dreExcel: (parametros, tipoEmissao) => {
      const url = `${getPath()}/relatorio/dre/excel?tipoEmissao=${tipoEmissao}`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    receitaExcel: (parametros) => {
      const url = `${getPath()}/relatorio/receita-lancamento/excel`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    receitaPdf: (parametros) => {
      const url = `${getPath()}/relatorio/receita-lancamento/pdf`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    fluxoCaixaPdf: (parametros) => {
      const url = `${getPath()}/relatorio/fluxo-de-caixa/pdf`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    fluxoCaixaExcel: (parametros) => {
      const url = `${getPath()}/relatorio/fluxo-de-caixa/excel`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    balancetePdf: (parametros) => {
      const url = `${getPath()}/relatorio/balancete/pdf`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    balanceteExcel: (parametros) => {
      const url = `${getPath()}/relatorio/balancete/excel`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    despesaExcel: (parametros) => {
      const url = `${getPath()}/relatorio/despesa-lancamento/excel`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    despesaPdf: (parametros) => {
      const url = `${getPath()}/relatorio/despesa-lancamento/pdf`;
      return axios.post(url, parametros, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    estoqueExcel: () => {
      const url = `${getPath()}/estoque/excel`;
      return axios.get(url, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    recuperarSenhaCaptcha: (params) => {
      const url = `${getPath()}/recuperar-senha`;
      return axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          'x-tenantid': 'public',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    atualizarSenhaResetKey: (queryParams, params) => {
      const url = `${getPath()}/atualizar-senha?`;

      return axios.put(url.concat(queryParams), params, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          'x-tenantid': 'public',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    validarToken: (queryParams) => {
      const url = `${getPath()}/validar-token?`;

      return axios.get(url.concat(queryParams), {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          'x-tenantid': 'public',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    getUsuarioBasico: async (key, tenantId) => {
      const url = `${getPath()}/usuario?accessValidationKey=${key}`;
      return axios.get(url, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    atualizarUsuarioBasico: async (usuario, tenantId) => {
      const url = `${getPath()}/usuario/primeiro-acesso/${usuario.id}`;
      return axios.put(url, usuario, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    logarEmailPassword: async (email, senha, tenantId, ip) => {
      const url = `${getPath()}/usuario/login-email?ip=${ip}`;
      const credentials = { login: email, senha, clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID };
      return axios.post(url, credentials, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    getTermoUso: async (tenantId) => {
      const origem =
        process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? 'FATURE_MAIS' : 'GROUP_FINANCEIRO';
      const url = `${getPath()}/termo-uso?origem=${origem}`;
      return axios.get(url, {
        headers: {
          'X-TenantID': tenantId,
        },
      });
    },
    fluxoDeCaixaPdf: (params) => {
      const url = `${getPath()}/relatorio/fluxo-de-caixa/pdf`;

      return axios.post(url, params, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
      });
    },
    downloadZipCertidaoNegativa: (chavesFiltro) => {
      const axiosCustom = axiosDefault.create();
      const tenantId = getTenantToken();
      const tenant = atob(tenantId);
      axiosCustom.interceptors.request.use(
        function(config) {
          config.headers['X-TenantID'] = tenant;
          return config;
        },
        function(error) {
          return Promise.reject(error);
        }
      );

      const url = `${getPath()}/relatorio/certidao-negativa-zip/${chavesFiltro}`;
      return axiosCustom.get(url);
    },
    fluxoDeCaixaExcel: (params) => {
      const url = `${getPath()}/relatorio/fluxo-de-caixa/excel`;

      return axios.post(url, params, {
        headers: {
          'X-TenantID': window.atob(getTenantToken()),
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
      });
    },
    getRelatorioPdf: (chaveFiltro, tenant, gestaoEnvioId) => {
      const axiosCustom = axiosDefault.create();

      axiosCustom.interceptors.request.use(
        function(config) {
          config.headers['X-TenantID'] = tenant;
          return config;
        },
        function(error) {
          // Do something with request error
          return Promise.reject(error);
        }
      );
      if (gestaoEnvioId !== undefined) {
        const url = `${getPath()}/relatorio/pdf/${chaveFiltro}?g=${gestaoEnvioId}`;
        return axiosCustom.get(url);
      } else {
        const url = `${getPath()}/relatorio/pdf/${chaveFiltro}`;
        return axiosCustom.get(url);
      }
    },
  };
};

export { publicoApi };
